import { RefObject } from 'react';
import { VideoCropPosition } from '@goldcast/player-config/src/types/RemotionPlayerConfigTypes/Scene';
import { SelectionElementType } from '@goldcast/player-config/src/types/RemotionPlayerConfigTypes/CompositionConfig';

export { SelectionElementType };

export enum SelectionOutlineAction {
  SELECT = 'SELECT',
  DESELECT = 'DESELECT',
  UPDATE_POSITION = 'UPDATE_POSITION'
}

export type CaptionsSelectionElementData = { type: SelectionElementType.CAPTIONS };
export type SpeakerLabelSelectionElementData = { speakerId: string; type: SelectionElementType.SPEAKER_LABEL };
export type ImageOverlaySelectionElementData = { elementId: string; type: SelectionElementType.IMAGE };
export type TextSelectionElementData = { elementId: string; type: SelectionElementType.TEXT };
export type VideoOverlaySelectionElementData = { elementId: string; type: SelectionElementType.VIDEO };
export type CompositeVideoSelectionElementData = {
  elementId: string;
  type: SelectionElementType.VIDEO_IN_COMPOSITE;
  // TODO we can also use dataURL instead of passing the ref for the image. By pausing the video while selection is active.
  videoElementRef: RefObject<HTMLDivElement>;
  videoUrl?: string;
  compositeSegmentId: string;
  videoAspectRatio: number;
  cropInformation?: VideoCropPosition;
};
export type LottieOverlaySelectionElementData = { elementId: string; type: SelectionElementType.LOTTIE };
export type SelectionElementData =
  | CaptionsSelectionElementData
  | SpeakerLabelSelectionElementData
  | ImageOverlaySelectionElementData
  | TextSelectionElementData
  | VideoOverlaySelectionElementData
  | CompositeVideoSelectionElementData
  | LottieOverlaySelectionElementData;
